import { BlockType } from '../../types/index.js';
import { CardContentBlock as Component } from './Block.js';
export const RegisteredCardContentBlock = (_intl) => ({
    recommendedName: 'Card.Content',
    Component,
    config: {
        type: BlockType.BuildingBlock,
    },
});
//# sourceMappingURL=registered.js.map